/**
 * Bug #438
 * @Author Anupama P
 * @Date 1 Jul 2021
 */

import { Alert } from 'antd'
import { useEffect, useState } from 'react';
export enum Type {
    error, success, info, warning
}

export default function AlertMessage({ message, type, className = null, ...props }) {
    const [visible, setVisible] = useState(true);
    useEffect(() => {
        setTimeout(() => {
            setVisible(false);
        }, 5000)
    }, []);  {/**Bug #632 author Midhila Velayudhan Date :19/10/2021 alert message auto close  */}

    switch (type) {
        case Type.error:
            return (

                <Alert className={`alert-margin alert-background-color ${className}`} message={message} type="error" {...props} />
            )

        case Type.success:
            return (
                visible &&
                <Alert className={`alert-margin ${className}`} message={message} type="success" {...props} />
            )
        case Type.info:
            return (

                <Alert className={`alert-margin ${className}`} message={message} type="info" {...props} />
            )
        case Type.warning:
            return (

                <Alert className={`alert-margin ${className}`} message={message} type="warning" {...props} />
            )


    }
}
/** End */